/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from 'react';
import { Link, NavLink, Outlet } from "react-router-dom";
import BaseCom from '../components/BaseCom';
import Icon from '../components/Icon';
import L from '../components/Lang';
import { ErrorAlertModal } from '../components/ErrorAlertModal';
import { PopModal } from '../components/PopModal';
import LangIcon from '../components/LangIcon';

export default class ClientLayout extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {};
    }

    async componentDidMount() {
        this.importCSS('/css/client.css');
        await this.getMainOrg((j) => {
            this.setState({ instanceError: j.errorMessage })
        });
        const u = await this.getLoginAsync();
        this.setState({ user: u });
    }

    componentWillUnmount() {
        this.undefineCSS('/css/client.css');
    }

    toggleNav = () => {
        this.setState({ showNav: !this.state.showNav });
    }

    render() {
        return (
            <>
                <PopModal />
                <ErrorAlertModal />
                <header id="client-header">
                    <div className="topbar">
                        <div className="container">
                            <div className="d-flex justify-content-end align-items-center py-3">
                                {!this.state.user && <>
                                    <div className="ms-4">
                                        <NavLink to="/client/login"><L>Login</L></NavLink>
                                    </div>
                                    <div className="ms-4">
                                        <NavLink to="/client/signup"><L>Sign Up</L></NavLink>
                                    </div>
                                </>}
                                {this.state.user && <div>
                                    <span className="d-none d-md-inline">{this.state.user.name}</span> <Icon icon="faUser" />
                                </div>}
                                <LangIcon className="ms-3" />
                            </div>
                        </div>
                    </div>
                    <nav className="navbar navbar-expand-lg">
                        <div className="container">

                            {/* Brand */}
                            <Link className="navbar-brand d-block" to="/client">
                                <img src={this.getMainOrgLogoURL()} alt={this.state.org?.name} className="img-fluid logo" />
                            </Link>

                            {/* Toggle (mobile) */}
                            {this.state.user && <button
                                className="navbar-toggler ms-2"
                                type="button"
                                onClick={this.toggleNav}
                            >
                                <span className="navbar-toggler-icon navbar-toggler-icon-dark"></span>
                            </button>}

                            {/* Nav items */}
                            {this.state.user && <>
                                <div className={'collapse navbar-collapse' + (this.state.showNav ? ' show' : '')}>
                                    <ul className="navbar-nav ms-auto">
                                        <li className="nav-item">
                                            <NavLink className="nav-link" to="/client/appointment"><L>Appointments</L></NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink to="/logout" onClick={(e) => this.logout(e, '/client/login')} className="nav-link">
                                                <L>Logout</L>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </>}
                        </div>

                    </nav>
                </header >
                <main id="client-main">
                    <Outlet />
                </main>
            </>
        );
    }
}